import { motion } from 'framer-motion';

type HoverIndicatorProps = {
    pill: boolean;
    colorMode: 'dark' | 'light';
};

export function HoverIndicator({ pill, colorMode }: HoverIndicatorProps): JSX.Element {
    return pill ? (
        <div
            className={`${
                colorMode === 'light' ? 'bg-gray-100' : 'bg-indigo-800/50'
            } h-full w-full absolute left-0 top-0 rounded-md py-2 -z-10 dark:bg-white/[0.09] dark:text-indigo-100 text-indigo-700 invisible group-hover:visible`}
        ></div>
    ) : (
        <div
            className={`${
                colorMode === 'light' ? 'bg-gray-300 dark:bg-gray-600' : 'bg-gray-300 dark:bg-gray-400'
            } absolute bottom-0 w-full left-0 invisible group-hover:visible h-[2px]`}
        ></div>
    );
}

type SelectedIndicatorProps = {
    pill: boolean;
    colorMode: 'dark' | 'light';
};

export function SelectedIndicator({ pill, colorMode }: SelectedIndicatorProps): JSX.Element {
    return pill ? (
        <motion.div
            initial={false}
            layoutId="pillbg"
            transition={{ duration: 0.2 }}
            className={`${
                colorMode === 'light' ? 'bg-indigo-50 dark:bg-indigo-900' : 'bg-indigo-800 dark:bg-indigo-900'
            } h-full w-full absolute left-0 top-0 rounded-md py-2 -z-10 dark:text-indigo-100 text-indigo-700`}
        ></motion.div>
    ) : (
        <motion.div
            initial={false}
            layoutId="bborder"
            transition={{ duration: 0.2 }}
            className={`${colorMode === 'light' ? 'bg-indigo-600' : 'bg-white dark:'} absolute bottom-0 w-full left-0 z-10 h-[2px]`}
        ></motion.div>
    );
}
